var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('medkitlogs.firstResponderNeeded'),"data-cy":"firstAid"},model:{value:(_vm.value.firstAid),callback:function ($$v) {_vm.$set(_vm.value, "firstAid", $$v)},expression:"value.firstAid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }